import { useState, useEffect } from 'react';
import useAuth from './useAuth';
import { normalizeFavorites } from '../utils/favorites';

export const useFavoritesCount = () => {
  const [count, setCount] = useState(0);
  const { user, isLoggedIn } = useAuth();

  useEffect(() => {
    // Se não estiver logado, sempre retorna 0
    if (!isLoggedIn || !user) {
      setCount(0);
      return;
    }

    const loadCount = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        if (!token) {
          setCount(0);
          return;
        }

        try {
          let userId = null;
          try {
            const payload = JSON.parse(atob(token.split('.')[1] || '')) || {};
            userId = payload.codigo || payload.id || payload.userId || payload.idUSUARIO || payload.codigoUSUARIO || payload.usuarioId || null;
          } catch {}

          if (!userId) {
            try {
              const raw = localStorage.getItem('user');
              if (raw) {
                const u = JSON.parse(raw);
                userId = u?.id || u?.idUSUARIO || u?.codigoUSUARIO || u?.userId || u?.usuarioId || null;
              }
            } catch {}
          }

          if (!userId) {
            setCount(0);
            return;
          }

          let arr = [];

          // Apenas endpoint por usuário para não mostrar contagem divergente
          try {
            const resUser = await fetch(`${import.meta.env.VITE_URL_API}/favoritos/usuario/${userId}`, {
              headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${token}`
              }
            });
            if (resUser.ok) {
              const dataUser = await resUser.json();
              arr = normalizeFavorites(dataUser);
            }
          } catch {}

          const getImovelId = (item) => (
            item?.imovelFAVORITO ||
            item?.codigoIMOVEL ||
            item?.idIMOVEL ||
            item?.imovel?.codigoIMOVEL ||
            item?.imovel?.id ||
            null
          );

          const valid = arr.filter((item) => !!getImovelId(item));
          const seen = new Set();
          const deduped = valid.filter((item) => {
            const key = String(getImovelId(item));
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });

          setCount(deduped.length || 0);
        } catch {
          setCount(0);
        }
      } catch {
        setCount(0);
      }
    };

    loadCount();
    
    // Recarrega ao focar na janela ou quando evento customizado disparar
    const onFocus = () => loadCount();
    const onFavoritesChange = () => loadCount();
    
    window.addEventListener('focus', onFocus);
    window.addEventListener('favoritesChanged', onFavoritesChange);
    
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('favoritesChanged', onFavoritesChange);
    };
  }, [user, isLoggedIn]);

  return count;
};
